import config from '../config';
import { Platform } from 'react-native';

const prefixes = [config.DEEPLINK_URL, config.WEB_HEADER_LOGO_REDIRECTION_URL + '#'];

if (Platform.OS === 'web') {
  const publicPath = '/' + (process.env.PUBLIC_PATH || '');
  prefixes.push(window.location.origin + publicPath);
}

export const linkingConfig = {
  prefixes,
  config: {
    screens: {
      login: {
        path: 'login',
        screens: {
          auth: 'auth',
          resetPasswordConfirmation: 'resetPasswordConfirmation',
        },
      },
      friendInvitation: 'friendInvitation',
    },
  },
};
